import type { LgTranslateService } from "@logex/framework/lg-localization";
import {
    OrderedItemErrorType,
    type OrderedItemErrorState
} from "../lg-ordered-item-selector.model";

export function getErrorState(
    menuLength: number,
    selectedLength: number,
    minItems: number,
    maxItems: number,
    translate: LgTranslateService
): OrderedItemErrorState | null {
    // Config errors
    if (minItems > maxItems) {
        console.error(
            `[OrderedItemSelector] Config error: minItems (${minItems}) is greater than maxItems (${maxItems}).`
        );
        return {
            message: translate.translate("._Errors.InvalidConfig", { minItems, maxItems }),
            icon: "icon-error",
            type: OrderedItemErrorType.Error
        };
    }

    if (menuLength < minItems) {
        console.error(
            `[OrderedItemSelector] Config error: Menu has ${menuLength} items but minItems is set to ${minItems}.`
        );
        return {
            message: translate.translate("._Errors.MinMenuItems", { minItems }),
            icon: "icon-error",
            type: OrderedItemErrorType.Error
        };
    }

    // State errors - user can fix these
    if (selectedLength > maxItems) {
        return {
            message: translate.translate("._Errors.AboveMax", { maxItems }),
            icon: "icon-error",
            type: OrderedItemErrorType.Error
        };
    }

    if (selectedLength < minItems) {
        return {
            message: translate.translate("._Errors.Min", { minItems }),
            icon: "icon-warning",
            type: OrderedItemErrorType.Warning
        };
    }

    // Info - valid state, just informing
    if (selectedLength === maxItems) {
        return {
            message: translate.translate("._Info.MaxReached", { maxItems }),
            icon: "icon-info",
            type: OrderedItemErrorType.Info
        };
    }

    return null;
}
